import { Header } from '@/components/Layout/Header/Header';
import UserStatistics from '@/components/Views/Users/UserStatistics';
import { UsersList } from '@/components/Views/Users/UsersList';
import { useUsersList } from '@/components/Views/Users/useUsersList';
import { FadeLoader } from 'react-spinners';

const Users = () => {
  const { lodingDataList, loadingStats } = useUsersList();

  const RenderLoader = () => (
    <div className="w-full h-[100vh] flex items-center justify-center">
      <FadeLoader color="#FEC200" />
    </div>
  );

  return (
    <div>
      <Header title="Gestion des utilisateurs" />

      {loadingStats ? (
        <RenderLoader />
      ) : (
        <>
          <UserStatistics />
          {lodingDataList ? <RenderLoader /> : <UsersList />}
        </>
      )}
    </div>
  );
};

export default Users;
